export default [
    {
        path: '/avatares',
        meta: { nombre: 'Avatares' },
        name: 'avatares',
        component: () => import(/* webpackChunkName: "promociones" */ '../../pages/avatares').then(m => m.default || m)
    }
]
